import axios from "axios";
import { ApiBaseUrl } from "@/utils/Consts/ApiConsts";

// Inicio de sesión con Zoho. La API arma la URL de autorización (tiene el client id y
// el redirect) y canjea el code; acá solo se genera y comprueba el `state`, que evita
// que alguien complete el login con un code suyo (CSRF).
const CLAVE_STATE = "zoho-sso-state";
const CLAVE_AVISO = "zoho-sso-aviso";

export type TipoAviso = "pendiente" | "error";
export interface AvisoLogin {
  tipo: TipoAviso;
  mensaje: string;
}

const generarState = (): string => {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};

/** Pide la URL de autorización a la API y manda al usuario a Zoho. */
export const iniciarLoginZoho = async (): Promise<void> => {
  const state = generarState();
  sessionStorage.setItem(CLAVE_STATE, state);
  const { data } = await axios.get(`${ApiBaseUrl}backoffice/zoho/url`, { params: { state } });
  window.location.href = data.url;
};

/** Compara el state que volvió de Zoho con el guardado. Se consume una sola vez. */
export const consumirState = (recibido: string | null): boolean => {
  const guardado = sessionStorage.getItem(CLAVE_STATE);
  sessionStorage.removeItem(CLAVE_STATE);
  return !!guardado && !!recibido && guardado === recibido;
};

// El callback redirige al login y el aviso se muestra ahí, con el mismo banner que
// los errores de usuario y contraseña.
export const guardarAviso = (aviso: AvisoLogin) =>
  sessionStorage.setItem(CLAVE_AVISO, JSON.stringify(aviso));

export const consumirAviso = (): AvisoLogin | null => {
  const crudo = sessionStorage.getItem(CLAVE_AVISO);
  sessionStorage.removeItem(CLAVE_AVISO);
  if (!crudo) return null;
  try {
    return JSON.parse(crudo) as AvisoLogin;
  } catch {
    return null;
  }
};
